const Utils = {
    calculateAge: (birthDateString) => {
        const [day, month, year] = birthDateString.split("/").map(Number);
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();

        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
        ) {
            age -= 1;
        }

        return age;
    },

    stripHTML: (html) => {
        const doc = new DOMParser().parseFromString(html || '', 'text/html');
        return doc.body.textContent || '';
    },

    // Validador de CPF
    validateCPF: (cpf) => {
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(cpf.charAt(i)) * (10 - i);
        }
        let rev = 11 - (sum % 11);
        if (rev === 10 || rev === 11) rev = 0;
        if (rev !== parseInt(cpf.charAt(9))) return false;

        sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += parseInt(cpf.charAt(i)) * (11 - i);
        }
        rev = 11 - (sum % 11);
        if (rev === 10 || rev === 11) rev = 0;
        if (rev !== parseInt(cpf.charAt(10))) return false;

        return true;
    },

    slug: (string) => {
        const slug = Utils.stripHTML(string)
            .toString()
            .normalize('NFD')                   // remove acentos
            .replace(/[\u0300-\u036f]/g, '')    // remove diacríticos
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, '')       // remove caracteres especiais
            .replace(/\s+/g, '-')               // troca espaços por hífens
            .replace(/-+/g, '-');               // remove múltiplos hífens
        return slug;
    },

    stripHTMLKeepBreaks: (html) => {
        return html
        .replace(/<br\s*\/?>/gi, '\n') // transforma <br> em \n
        .replace(/<[^>]+>/g, '');      // remove o restante das tags
    },

    formatDate: (dateTimeString) => {
        if (!dateTimeString) return '';
        const datePart = dateTimeString.split(' ')[0];
        if (!datePart) return '';
        const [year, month, day] = datePart.split('-');
        if (!year || !month || !day) return dateTimeString;
        return `${day}/${month}/${year}`;
    },

    formatDateTime: (dateTimeString) => {
        if (!dateTimeString) return '';

        const [datePart, timePart] = dateTimeString.split(' ');

        if (!datePart) return '';

        const [year, month, day] = datePart.split('-');

        if (timePart) {
            const [hour, minute] = timePart.split(':');
            return `${day}/${month}/${year} ${hour}:${minute}`;
        }

        // Se não tiver hora, retorna só a data
        return `${day}/${month}/${year}`;
    },

    isLightColor: (hex) => {
        // Remove o "#" se estiver presente
        hex = hex.replace('#', '');
      
        // Converte para componentes RGB
        const r = parseInt(hex.substring(0, 2), 16) / 255;
        const g = parseInt(hex.substring(2, 4), 16) / 255;
        const b = parseInt(hex.substring(4, 6), 16) / 255;
      
        // Aplica correção gamma (sRGB)
        const [R, G, B] = [r, g, b].map(c =>
          c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
        );
      
        // Calcula a luminosidade relativa
        const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B;
      
        return luminance > 0.5;
    },

    parsePrice: (value) => Number(String(value).replace(",", ".")),

    // Deadline do desconto extra de 5% do pin de lançamento
    LAUNCH_PIN_DEADLINE: new Date("2026-07-08T23:59:59-03:00"),

    hasActiveLaunchPin: () => {
        if (!localStorage.getItem("launchPin")) return false;
        return new Date() <= Utils.LAUNCH_PIN_DEADLINE;
    },

    firstName: (fullName) => {
        if (!fullName) return '';
        return fullName.trim().split(' ')[0];
    },

    getUserDocType: (user) =>
        String(user?.doc_type || user?.usr_doc_type || 'BR').toUpperCase(),

    isForeignUser: (user) => Utils.getUserDocType(user) !== 'BR',

    sanitizePassport: (value) =>
        String(value || '')
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, '')
            .slice(0, 20),

    isValidPassport: (value) =>
        /^[A-Z0-9]{1,20}$/.test(Utils.sanitizePassport(value)),

    isProfileDocumentValid: (user) => {
        const docType = Utils.getUserDocType(user);
        const document = String(user?.cpf || user?.usr_cpf || '').trim();
        if (!document) return false;
        if (docType === 'BR') return Utils.validateCPF(document);
        return Utils.isValidPassport(document);
    },

    isProfileComplete: (user) => {
        if (!user) return false;
        const genderId = user.gender?.id ?? user.usr_gender;
        const phone = user.cell_phone || user.usr_phone;
        return (
            Utils.isProfileDocumentValid(user) &&
            !!user.birth &&
            genderId !== null &&
            genderId !== undefined &&
            String(genderId) !== '' &&
            !!phone
        );
    },

};


export default Utils;